import React from 'react';

/**
 * Element to add vertical spacing
 */
const CmsSpacer = ({ height }) => {
  /*
   * changed due to WP Version 5.9.1
   */
  const spacer = height?.toString().includes('px') ? height : `${height}px`;
  return <div style={{ paddingBottom: spacer }} />;
};
export default CmsSpacer;
